<template>
  <div v-if="currentCandidature">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-responsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Nom</span>
                  </td>
                  <td>
                    {{ currentCandidature.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i
                      :class="icons.ICON_CALENDAR"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Date de naissance</span>
                  </td>
                  <td>
                    {{ currentCandidature.date_naissance }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Pays de naissance</span>
                  </td>
                  <td>
                    {{ currentCandidature.pays_naissance }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Adresse</span>
                  </td>
                  <td>
                    {{ currentCandidature.adresse }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Email</span>
                  </td>
                  <td>
                    {{ currentCandidature.email }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i :class="icons.ICON_USER" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentCandidature.document.created_by.prenom
                        ? currentCandidature.document.created_by.prenom +
                          ' ' +
                          currentCandidature.document.created_by.nom
                        : currentCandidature.document.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Prénom</span>
                  </td>
                  <td>
                    {{ currentCandidature.prenom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Lieu de naissance</span>
                  </td>
                  <td>
                    {{ currentCandidature.lieu_naissance }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Nationalité</span>
                  </td>
                  <td>
                    {{ currentCandidature.nationalite }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Ville</span>
                  </td>
                  <td>
                    {{ currentCandidature.ville }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Téléphone</span>
                  </td>
                  <td>
                    {{ currentCandidature.telephone }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VueEditorToolbar from '@/vue-editor-tool-bar';
import { show as icons } from '@/icons/rh/candidature';

export default {
  data() {
    return {
      VueEditorToolbar,
      icons,
    };
  },
  computed: {
    ...mapGetters('candidature', ['currentCandidature']),
  },
};
</script>

<style scoped></style>
